import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
  },

  field: {
    width: theme.spacing(57.4375),
    textAlign: 'left',
  },
  arnHelperRow: {
    marginTop: theme.spacing(0.5),
    minHeight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
  arnHintText: {
    fontSize: theme.spacing(1.5),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: theme.spacing(2),
    letterSpacing: '0.1px',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.description,
  },
  arnValidationErrorText: {
    fontSize: theme.spacing(1.5),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: theme.spacing(2),
    letterSpacing: '0.1px',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraV2Errors.main,
  },
  loadingText: {
    fontSize: theme.spacing(1.75),
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.1px',
  },
  textColor: {
    color: theme.palette.labraText.description,
  },
  successText: {
    color: theme.palette.labraText.tertiary,
  },
  loadingTextContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  loader: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    flexShrink: 0,
    color: theme.palette.labraText.tertiary,
  },
  check: {
    color: theme.palette.textBackground.dark,
  },
  buttonContainer: {
    marginTop: theme.spacing(0.625),
  },
  errorText: {
    color: theme.palette.labraV2Errors.main,
  },
  content: {
    display: 'flex',
    gap: `${theme.spacing(5)} !important`,
    flexDirection: 'row',
  },
  fieldsArnContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  arnInputAndStatus: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
}))
